import React from "react";
import { Autocomplete, Box, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import MyButton from "../myButton";


const MySearchOptions = ({label, values, valuesSelects, onSelect, getOptions, maximoSelecionados}) => {

    const [open, setOpen] = useState(false);
    const [valueSelected, setValueSelected] = useState(null);
    const [options, setOptions] = useState([]);
    const loading = open && values.length === 0;
    const [simNaoSelected, setSimNaoSelected] = useState(''); // Estado para a escolha "Sim" ou "Não"
    const [itensSelecao, setItensSelecao] = useState([]);

    const _setOptions = () =>{
        const filtro = (item) => {
            return valuesSelects?.filter(item2 => {
                if (item2.tipo_resposta === 2) {
                    const opcoes = JSON.parse(item2.templatelista_opcoes)
                    return valuesSelects?.filter((e => e.id === item2.id))?.length >= opcoes.length && item.id === item2.id

                } else {
                    return item.id === item2.id
                }
            
            }).length <= 0
        }
        let _values = values.filter(filtro)
        setOptions([..._values]);
    }

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {

        if (active) {
            await getOptions();
        }
        })();

        return () => {
        active = false;
        };
    }, [loading]);

    useEffect(() => {
        if (open) {
            _setOptions()
        }
    }, [values]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
        else {
            _setOptions()
        }
    }, [open]);

    useEffect(() => {
        if (valueSelected?.tipo_resposta === 1) {
            setItensSelecao([
                { nome: "Sim", ordem: 1 },
                { nome: "Não", ordem: 2 }
            ]);

        } else if (valueSelected?.tipo_resposta > 1) {
            let opcoes = JSON.parse(valueSelected.templatelista_opcoes);
            opcoes = opcoes.filter(item => 
                valuesSelects?.filter(item2 => item2.id === valueSelected.id && item.nome === item2.resposta)?.length <=0);
            setItensSelecao(opcoes || []);
        } else {
            setItensSelecao([]);
        }
    }, [valueSelected]);

    // Função para mudar a seleção de "Sim" ou "Não"
    const handleSimNaoChange = (event) => {
        setSimNaoSelected(event.target.value);
    }; 
    return (
        <Box sx={{display:'flex'}}>
            <Box sx={{flexGrow:1, marginRight:'10px', width: '70%'}}>
                <Autocomplete
                    size='small'
                    id={label}
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    value={valueSelected}
                    onChange={(event, newValue) => {
                        setValueSelected(newValue);
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    options={options}
                    loading={loading}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                        />
                    )}
                />
            </Box>
            {/* Seletor de Sim/Não */}
            <Box sx={{flexGrow:1, marginRight:'10px', width: '30%'}}>
                <FormControl size="small" fullWidth>
                    <InputLabel id="sim-nao-label">Resposta esperada </InputLabel>
                    <Select
                        labelId="sim-nao-label"
                        value={simNaoSelected}
                        label="Resposta esperada "
                        onChange={handleSimNaoChange}
                    >
                    {itensSelecao.map((item) => (
                    <MenuItem key={item.ordem} value={item.nome}>
                        {item.nome}
                    </MenuItem>
                    ))}                        
                    </Select>
                </FormControl>
            </Box>           
            <Box sx={{width:'122px'}}>
                <MyButton onClick={()=> {
                    if (valueSelected && simNaoSelected){
                        const select = {
                            ...valueSelected, // mantemos todos os campos de select
                            resposta: simNaoSelected // Adiciona o valor específico de select
                        };                             
                        setValueSelected(null)
                        setSimNaoSelected('')
                        onSelect(select)
                    }
                    }} variant='contained' text='Adicionar' color='secondary' disabled={maximoSelecionados === null ? false : valuesSelects.length >= maximoSelecionados}/>
            </Box>
        </Box>
    )
}

export default MySearchOptions